<script setup>
import items from './collectionsData';

// import { store } from '@store/store.js';
import { useRouter } from 'vue-router';

const router = useRouter();

const handleClick = ({ productId }) => {
    router.push({
        name: 'configurator',
        params: {
            productId: productId,
        },
    });
};
</script>

<template>
    <div class="grid gap-4">
        <div
            v-for="(item, index) in items"
            :key="index"
            class="g-col-6 g-col-lg-2 cursor-pointer d-flex flex-column align-items-center"
            @click="
                () => {
                    handleClick({ collection: item.slug, productId: item.productId });
                }
            "
        >
            <div class="border mb-3">
                <img
                :src="item.img"
                :alt="item.title || 'Collection image'"
                :title="item.title || 'Collection image'"
                class="img-fluid"
            />
            </div>

            <p class="mb-2 text-center fs-5">{{ item.label }}&reg;</p>

            <p class="mb-0 fs-8 text-decoration-underline text-uppercase">
                {{ $t('home-new.text9') }}
            </p>

            <!-- <img
                :src="item.logo"
                :alt="item.title || 'Collection image'"
                class="d-lg-none"
                height="30"
            />
            <img
                :src="item.logo"
                :alt="item.title || 'Collection image'"
                :title="item.title || 'Collection image'"
                class="d-none d-lg-inline-block"
                height="35"
            /> -->
        </div>
    </div>
</template>
